import { forwardRef } from 'react';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { splitButtonStyleBuilder } from './splitButtonStyleBuilder';
import { MeatBallButton } from './MeatBallButton';
import { SplitButtonDivider } from './SplitButtonDivider';
import { Stack } from '@mui/material';
import { Button } from '../../Button';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SplitButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    onClick,
    buttonStyle,
    children,
    disabled,
    icon,
    id,
    options,
    size,
    ...rest
  } = _ref;
  const theme = useInterstateTheme();
  return /*#__PURE__*/_jsxs(Stack, {
    flexDirection: "row",
    divider: buttonStyle !== 'secondary' ? /*#__PURE__*/_jsx(SplitButtonDivider, {
      disabled: disabled
    }) : null,
    children: [/*#__PURE__*/_jsx(Button, {
      buttonStyle: buttonStyle,
      disabled: disabled,
      id: `${id}-button`,
      size: size,
      startIcon: icon,
      sx: splitButtonStyleBuilder(theme, buttonStyle, disabled),
      "data-testid": rest['data-testid'] ? `${rest['data-testid']}-button` : 'button-component',
      onClick: onClick,
      children: children
    }), /*#__PURE__*/_jsx(MeatBallButton, {
      buttonStyle: buttonStyle,
      id: id,
      disabled: disabled,
      size: size,
      options: options,
      ...rest
    })]
  });
});
SplitButton.displayName = 'SplitButton';